export default "__VITE_ASSET__CNWlHnsT__"